import { render, staticRenderFns } from "./QuestionsItem.vue?vue&type=template&id=eff3c392"
import script from "./QuestionsItem.vue?vue&type=script&lang=js"
export * from "./QuestionsItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionsItem.vue?vue&type=style&index=0&id=eff3c392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports